export function folderStatusText(collapsed: boolean, itemCount: number): string {
  if (itemCount === 0) {
    return collapsed ? "Drag items here to gather them." : "This folder is empty.";
  }

  return `${itemCount} ${itemCount === 1 ? "item" : "items"}`;
}
